import { Suspense } from "react";
import LoadingComponent from "./LoadingComponent";

export default ({ element }) => {
  return <Suspense fallback={<LoadingComponent />}>{element}</Suspense>;
};
